import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum FeatureEntitlement {
  included = 'included',
  upgrade = 'upgrade',
}

export default class CustomerModel extends Model {
  @attr('number') planVersion!: number;
  @attr('string') currency!: string;
  @attr('string') externalReference!: string;
  @attr('string') hmac!: string;
  @attr('boolean') annual!: boolean;
  @attr('boolean') subscribed!: boolean;
  @attr('boolean') pending!: boolean;
  @attr('string') planType!: string;
  @attr('string') planTier!: string;
  @attr('string') checkoutUrl!: string;
  @attr('string') referral!: string;
  @attr('boolean') legacyPlan!: boolean;
  @attr('number', { defaultValue: 0 }) adaptBillableListings!: number;
  @attr('array') bundledAddons!: string[];
  @attr('object') featureEntitlements!: Record<string, FeatureEntitlement>;

  @belongsTo('user', {
    inverse: 'customer',
    async: false,
  })
  user!: ModelRegistry['user'];

  @cached
  get canUpgrade(): boolean {
    return this.legacyPlan && this.subscribed;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    customer: CustomerModel;
  }
}
